<template>
	<div>
		<v-content>
			<v-container fluid>              
				<v-data-table :headers="headers" :search="search" ref="sortableTable" :items="projectStatusList" hide-actions class="elevation-1" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
					<template slot="items" slot-scope="props">
                      <tr class="sortableRow" id="rows">
                        <td width="5%" class="px-1" >
                          <v-btn style="cursor: move" icon class="sortHandle"><v-icon>drag_handle</v-icon></v-btn>
                        </td>
                        <td width="40%">{{ props.item.text }}</td>
                        <td width="35%" class="text-xs-right">{{ props.item.obj.tender_winning }}</td>
                        <!--<td class="text-xs-right">{{ props.item.obj.order }}</td>-->
                        <td width="10%" class="text-xs-right" v-if="objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_PROJECTS') !== -1"><a @click.prevent="fncEditStatus(props.item.obj.id)"><i class="material-icons">edit</i></a></td>
                        <td width="10%" class="text-xs-right" v-if="objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_PROJECTS') !== -1"><a@click.prevent ="fncDeleteStatus(props.item.obj.id)"><i class="material-icons">delete_forever</i></a></td>
                      </tr>
                    </template>
				</v-data-table>
			</v-container>
		</v-content> 
		<modal></modal>
	</div>
</template>

<script>
	
  import { mapGetters } from 'vuex';
  import Modal from '@/components/shared/modal';
  import Sortable from 'sortablejs';

  export default {
	name: 'StatusList',
	intRoleEdit: 0,
    data () {
		return {	
			search: '',
            headers: [
                { text: '', value: '', width: '5%' },
                { text: 'Description', value: 'description', width: '40%' },
                { text: 'Tender Winning Status', value: 'description', width: '35%' },
				//{ text: 'Order', value: 'description' },
                { text: 'Edit', value: 'edit', width: '10%' },				
                { text: 'Delete', value: 'delete', width: '10%' },				
			]
		}
	},
	methods: {
		fncEditStatus( statusId ) {
			this.$store.commit({
				type: 'setObjProjectStatusEdit',
				id: statusId
			});
			var modalDetails = { title: 'Edit Status', component: 'modal-project-status-edit', mstate: true, params: {statusId: statusId} };
			this.$store.commit({
				type: 'setModal',
				details: modalDetails
			});
		},
		fncDeleteStatus( statusId ) {
			var deleteConfirm = confirm('Are you sure you want to remove this status?');
			if(deleteConfirm === true) {
				this.$store.dispatch({
					type: 'fncDeleteProjectStatus',
					statusId: statusId
				})
			}
        },
        fncReorderProjectStatus({ oldIndex, newIndex }) {
          this.$store.dispatch({
            type: 'fncReorderProjectStatus',
            start: oldIndex,
            end: newIndex
          });
        }
	},
	computed: {
		...mapGetters([
			'objAuthorize',
			'projectStatusList',
			'globalModalParams'
		])
	},
	components: {
		Modal
	},
	beforeMount() {
		this.$store.dispatch('fncPopulateProjectStatusList');
    },
    mounted() {
      new Sortable(
        this.$refs.sortableTable.$el.getElementsByTagName('tbody')[0],
        {
          draggable: '.sortableRow',
          handle: '.sortHandle',
          onUpdate: this.fncReorderProjectStatus
        }
      )
    }
}	
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css'
</style>